export default __webpack_public_path__ + "static/media/badge-google-play.ab2c4e4a.svg";